module.exports = __webpack_public_path__ + "static/group-5-bd4e9d076301ba65a0cd314e8252fca7.jpg";